<div id="outer" class="well container">
    <div class="col-md-12">
        <div class="well-notify"></div>
    </div>
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="well-title">
        <div class="col-md-12">Search Documents</div>
    </div>
    <div class="col-md-12 well-content">
        <form (ngSubmit)="search()" #frm="ngForm" id="searchForm" role="form" class="form-horizontal">
            <div class="form-group">
                <div class="col-sm-4">
                    <div class="form-horizontal">
                        <div class="form-group">
                            <div class="col-sm-12">
                                <select
                                    size="4"
                                    name="documentTypes"
                                    multiple="multiple"
                                    id="documentTypes"
                                    class="form-control"
                                    [(ngModel)]="documentTypes"
                                    [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="updateCommonFields()"
                                    style="height: 165px; height: 245px">
                                    @for (opt of schema.Types; track opt) {
                                        <option [ngValue]="opt.Id">
                                            {{ opt.Name }}
                                        </option>
                                    }
                                </select>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="loadSearchList" class="col-sm-12 control-label pull-left">
                                Load Search Criteria
                            </label>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-sm-5">
                            <nz-select
                                name="loadSearchList"
                                [(ngModel)]="selectedSearch"
                                [ngModelOptions]="{standalone: true}"
                                id="loadSearchList"
                                style="width: 100%">
                                @for (search of searches; track search) {
                                    <nz-option [nzLabel]="search.Name" [nzValue]="search"> </nz-option>
                                }
                            </nz-select>
                        </div>
                        <nz-space-compact class="hidden-xs">
                            <button
                                nz-button
                                nzType="default"
                                name="LoadSearch"
                                id="LoadSearch"
                                [disabled]="!selectedSearch"
                                (click)="loadSearch()">
                                Load
                            </button>
                            <button
                                nz-button
                                nzDanger
                                name="deleteSearch"
                                id="DeleteSearch"
                                [disabled]="!selectedSearch"
                                (click)="deleteSearch()">
                                Delete
                            </button>
                        </nz-space-compact>
                    </div>
                </div>
                <div class="col-sm-8">
                    <div class="form-horizontal">
                        <div class="form-group">
                            <label for="fullTextBox" class="col-sm-12 control-label pull-left"> Full Text</label>
                        </div>
                        <div class="form-group">
                            <div class="col-sm-12">
                                <input
                                    name="fullTextBox"
                                    [(ngModel)]="fullText"
                                    [ngModelOptions]="{standalone: true}"
                                    type="text"
                                    id="fullTextBox"
                                    class="form-control" />
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="metaSearchField1" class="col-sm-12 control-label pull-left"> Keyword</label>
                        </div>
                        @for (item of keywords; track item) {
                            <div class="form-group filter-row">
                                <div class="col-sm-5">
                                    <nz-select
                                        style="padding: 0"
                                        [(ngModel)]="item.Id"
                                        [nzAllowClear]="true"
                                        nzShowSearch
                                        nzSelectOnTab
                                        (ngModelChange)="onKeywordChange(item)"
                                        [ngModelOptions]="{standalone: true}"
                                        nzNotFoundContent="No common fields between document type selection found"
                                        name="metaSearchField">
                                        @if (commonFields?.length > 0) {
                                            <nz-option [nzValue]="null" [nzLabel]=""></nz-option>
                                        }
                                        @for (opt of commonFields; track opt) {
                                            <nz-option [nzLabel]="opt.Name" [nzValue]="opt.Id"> </nz-option>
                                        }
                                    </nz-select>
                                </div>
                                <div class="col-sm-2">
                                    <nz-select
                                        [(ngModel)]="item.Operator"
                                        [ngModelOptions]="{standalone: true}"
                                        style="padding: 0"
                                        name="metaComparison">
                                        <nz-option nzLabel="=" [nzValue]="0"></nz-option>
                                        <nz-option nzLabel="&lt;=" [nzValue]="5" nzValue="&lt;="></nz-option>
                                        <nz-option nzLabel="&lt;" [nzValue]="3" nzValue="&lt;"></nz-option>
                                        <nz-option nzLabel="&gt;=" [nzValue]="4" nzValue="&gt;="></nz-option>
                                        <nz-option nzLabel="&gt;" [nzValue]="2" nzValue="&gt;"></nz-option>
                                        @if (item.Type === 1) {
                                            <nz-option nzLabel="Contains" [nzValue]="1"></nz-option>
                                        }
                                    </nz-select>
                                </div>
                                <div class="col-sm-5">
                                    @if (item.Type !== 3) {
                                        <input
                                            name="metaSearchValue"
                                            type="text"
                                            [(ngModel)]="item.Value"
                                            [ngModelOptions]="{standalone: true}"
                                            class="form-control"
                                            style="width: 100%" />
                                    } @else {
                                        <nz-date-picker
                                            style="width: 100%"
                                            name="metaSearchValue"
                                            [nzPlaceHolder]="' '"
                                            [(ngModel)]="item.DateValue"
                                            (ngModelChange)="onDateChange(item)"
                                            nzFormat="MM/dd/yyyy"
                                            [ngModelOptions]="{standalone: true}"></nz-date-picker>
                                    }
                                </div>
                            </div>
                        }

                        <div class="form-group">
                            <label class="col-sm-12 control-label pull-left" for="archiveDateComparison">
                                Archive Date<br />
                            </label>
                        </div>
                        <div class="form-group">
                            <div class="col-sm-2">
                                <nz-select
                                    [(ngModel)]="archiveDateOperator"
                                    [ngModelOptions]="{standalone: true}"
                                    name="archiveDateComparison"
                                    id="archiveDateComparison">
                                    <nz-option nzLabel="=" [nzValue]="0"></nz-option>
                                    <nz-option nzLabel="&lt;=" [nzValue]="5" nzValue="&lt;="></nz-option>
                                    <nz-option nzLabel="&lt;" [nzValue]="3" nzValue="&lt;"></nz-option>
                                    <nz-option nzLabel="&gt;=" [nzValue]="4" nzValue="&gt;="></nz-option>
                                    <nz-option nzLabel="&gt;" [nzValue]="2" nzValue="&gt;"></nz-option>
                                </nz-select>
                            </div>
                            <div class="col-sm-3">
                                <nz-date-picker
                                    [nzAllowClear]="true"
                                    [(ngModel)]="archiveDate"
                                    [ngModelOptions]="{standalone: true}"
                                    [nzPlaceHolder]="' '"></nz-date-picker>
                            </div>
                            <div class="col-sm-2"></div>
                            <div class="col-sm-5">
                                <div class="btn-group pull-right" role="group">
                                    <input
                                        type="submit"
                                        name="SearchButton"
                                        value="Search"
                                        id="SearchButton"
                                        class="btn btn-default" />
                                    <input
                                        type="button"
                                        name="searchCurrent"
                                        value="Filter Results"
                                        (click)="search(true)"
                                        id="searchCurrent"
                                        class="btn btn-default" />
                                    <button type="button" (click)="saveSearch()" type="button" class="btn btn-default">
                                        <nz-icon nzType="save" nzTheme="fill" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="clear: both"></div>
            @if (searched) {
                <div class="row">
                    <div class="row result-info-row">
                        <div class="col-sm-12 result-count">
                            <h4 style="font-size: 14px" id="searchTextFriendly">
                                {{ results.FriendlySearch }}
                            </h4>
                            <span id="searchText" style="display: none">{{ results.Search }}</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4" style="padding: 0 !important">
                        <nz-space-compact>
                            <nz-select
                                nzPlaceHolder="Action"
                                [(ngModel)]="searchAction"
                                [ngModelOptions]="{standalone: true}"
                                style="width: 120px">
                                <nz-option nzValue="email" nzLabel="Email"></nz-option>
                                <nz-option nzValue="zip" nzLabel="Zip"></nz-option>
                                <nz-option nzValue="print" nzLabel="Print"></nz-option>
                                <nz-option nzValue="delete" nzLabel="Delete"></nz-option>
                            </nz-select>
                            <button
                                nz-button
                                [nzLoading]="processing"
                                type="button"
                                nzType="default"
                                (click)="processSelected()">
                                Selected
                            </button>
                            <button
                                nz-button
                                [nzLoading]="processingAll"
                                type="button"
                                nzType="default"
                                (click)="processSelectedAll()">
                                All Results
                            </button>
                        </nz-space-compact>
                    </div>
                    <div class="col-sm-offset-4 col-sm-4" style="padding: 0 !important">
                        <div class="pull-right">
                            <nz-space-compact>
                                <nz-select
                                    name="SortResults"
                                    id="SortResults"
                                    nzInputAddonBefore="Sort"
                                    [(ngModel)]="sort"
                                    [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="onSortChange()">
                                    <nz-option nzLabel="Newest to Oldest" [nzValue]="1"></nz-option>
                                    <nz-option nzLabel="Oldest to Newest" [nzValue]="0"></nz-option>
                                    <nz-option nzLabel="Most Relevant" [nzValue]="2"></nz-option>
                                </nz-select>
                                <button
                                    (click)="export()"
                                    [nzLoading]="exporting"
                                    type="button"
                                    nz-button
                                    nz-tooltip="Export {{ (checkedTotal ? checkedTotal : results.Total) | number }}{{
                                        checkedTotal ? ' selected' : ''
                                    }} results to CSV">
                                    <nz-icon nzType="file-excel" nzTheme="fill" />
                                </button>
                            </nz-space-compact>
                        </div>
                    </div>
                </div>
                <div style="margin-top: 5px"></div>
                <div class="row">
                    <div class="col-md-12 resultstop">
                        <div class="row">
                            <div class="col-sm-4">
                                <input
                                    id="selectTop"
                                    [(ngModel)]="allChecked"
                                    [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="allCheckedChange()"
                                    type="checkbox"
                                    name="selectAll" />
                                <b>{{ results.Total }}&nbsp;Results</b> | Results Per Page:&nbsp;
                                <select
                                    name="ResultsDropdown"
                                    id="ResultsDropdown"
                                    [(ngModel)]="pageSize"
                                    [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="onPageSizeChange()"
                                    class="form-control results-per-page">
                                    <option [ngValue]="10">10</option>
                                    <option [ngValue]="50">50</option>
                                    <option [ngValue]="100">100</option>
                                </select>
                            </div>
                            <div class="col-sm-4 col-sm-offset-4">
                                <ng-container [ngTemplateOutlet]="pageControls"></ng-container>
                            </div>
                        </div>
                    </div>
                </div>
                <table id="results" width="100%" cellspacing="0" cellpadding="0">
                    <tbody>
                        <tr>
                            <td colspan="4"></td>
                        </tr>
                    </tbody>
                </table>
                <div class="row"></div>
                @if (results.Total === 0) {
                    <div class="row mt-3 mb-2">
                        <h4 style="font-size: 14px">Search yielded zero results</h4>
                    </div>
                }
                @for (doc of results.Documents; track doc) {
                    <div class="row result-row">
                        <div class="col-md-1" style="width: 10px">
                            <input
                                [(ngModel)]="doc.Checked"
                                (ngModelChange)="setCheckedCount()"
                                [ngModelOptions]="{standalone: true}"
                                type="checkbox" />
                        </div>
                        <div class="col-md-7">
                            <a
                                style="cursor: pointer"
                                (click)="openDocFile($safeNavigationMigration(doc.Files?.[0]?.Id), false)"
                                ><b>{{ doc.DocumentType.Name }} - {{ doc.Name }}</b></a
                            >
                            @if (downloadingFileId === doc.Files?.[0]?.Id && !downloadingInline) {
                                <nz-icon nzType="loading" nzSpin class="download-spinner" />
                            }
                            @if (doc.Notes.length) {
                                <a target="_blank" routerLink="/document/documentedit" [queryParams]="{id: doc.Id}">
                                    <img
                                        src="assets/images/notepad.png"
                                        alt="notes"
                                        [safeTooltip]="getDocumentNotes(doc)" />
                                </a>
                            }
                            <br /><br /><i>Archive Date: {{ doc.ArchiveDate | date: "medium" }}</i
                            ><br /><br /><a routerLink="/document/documentedit" [queryParams]="{id: doc.Id}"
                                >View Details</a
                            >
                            @for (file of doc.Files; track file) {
                                <br /><span
                                    ><a style="cursor: pointer" (click)="openDocFile(file.Id, true)"
                                        >View {{ file.FileType }}</a
                                    >
                                    @if (downloadingFileId === file.Id && downloadingInline) {
                                        <nz-icon nzType="loading" nzSpin class="download-spinner" />
                                    }
                                    <br
                                /></span>
                            }
                        </div>
                        <div class="col-md-4 pull-right">
                            @for (meta of doc.Keywords; track meta) {
                                {{ meta.Name }}: {{ meta.Value }}<br />
                            }
                        </div>
                    </div>
                }
                <div class="row resultstop">
                    <div class="col-sm-4">
                        <input
                            id="selectTop"
                            [(ngModel)]="allChecked"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="allCheckedChange()"
                            type="checkbox"
                            name="selectAll" />
                        <b>{{ results.Total }}&nbsp;Results</b> | Results Per Page:&nbsp;
                        <select
                            name="ResultsDropdown"
                            id="ResultsDropdown"
                            [(ngModel)]="pageSize"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="onPageSizeChange()"
                            class="form-control results-per-page">
                            <option [ngValue]="10">10</option>
                            <option [ngValue]="50">50</option>
                            <option [ngValue]="100">100</option>
                        </select>
                    </div>
                    <div class="col-sm-4 col-sm-offset-4">
                        <ng-container [ngTemplateOutlet]="pageControls"></ng-container>
                    </div>
                </div>
            }
        </form>
    </div>
</div>
<ng-template #pageControls>
    <div class="pull-right">
        @if (page > 0) {
            <a class="no-select" (click)="previousPage()">◄ Back</a>
        }
        &nbsp;{{ searchedPage * searchedPageSize + 1 }}-{{ searchedPage * searchedPageSize + results.Returned }}&nbsp;
        @if (hasMorePages) {
            <a class="no-select" (click)="nextPage()">Next ►</a>
        }
    </div>
</ng-template>
